import { Trans } from '@lingui/react/macro';
import { NoddiIcon } from 'noddi-ui-common';

export const BookingDeliveryAnnouncement = () => {
  return (
    <div className='animate-in rounded-lg border bg-white p-4 shadow-xs duration-500 fade-in-0 slide-in-from-right-4'>
      <div className='flex items-center gap-2'>
        <NoddiIcon name='CheckCircle' />
        <p>
          <Trans>Great news! We deliver to your area</Trans>
        </p>
      </div>
      <p className='pl-5 text-sm text-muted-foreground'>
        <Trans>You can proceed with booking your services at your location</Trans>
      </p>
    </div>
  );
};
